module.exports = [
  {
    title: 'Aggiolight',
    link: 'http://www.aggiolight.com/en/download/'
  },
  {
    title: 'Alberta',
    link: 'https://www.alberta.it'
  },
  {
    title: 'Alias',
    link: 'http://alias.design'
  },
  {
    title: 'Alivar',
    link: 'http://www.alivar.com.ru'
  },
  {
    title: 'Alma design',
    link: 'http://www.alma-design.it/en/'
  },
  {
    title: 'Andreu World',
    link: 'https://www.andreuworld.com'
  },
  {
    title: 'Arflex',
    link: 'http://www.arflex.it'
  },
  {
    title: 'Ariel zuckerman',
    link: 'http://ariel-design.com'
  },
  {
    title: 'Arketipo',
    link: 'https://www.arketipo.com'
  },
  {
    title: 'Arper',
    link: 'https://www.arper.com/ww/en/'
  },
  {
    title: 'Arredo 3',
    link: 'https://www.arredo3.it'
  },
  {
    title: 'Arrmet',
    link: 'https://www.arrmet.it'
  },
  {
    title: 'Artek',
    link: 'https://www.artek.fi/en/'
  },
  {
    title: 'Artemide',
    link: 'https://www.artemide.com/en/home'
  },
  {
    title: 'Artisan',
    link: 'https://www.artisan.ba/en/products'
  },
  {
    title: 'B&B Italia',
    link: 'https://www.bebitalia.com/ru'
  },
  {
    title: 'Baxter',
    link: 'https://www.baxter.it/it'
  },
  {
    title: 'BD Barcelona Design',
    link: 'https://bdbarcelona.com'
  },
  {
    title: 'Bentu Design',
    link: 'https://bentuone.com/pages/g000029'
  },
  {
    title: 'Bert Frank',
    link: 'http://bertfrank.co.uk'
  },
  {
    title: 'Bizzotto',
    link: 'http://www.bizzottoitalia.com/ru/home.html#posizione'
  },
  {
    title: 'Boca do Lobo',
    link: 'https://www.bocadolobo.com/en/'
  },
  {
    title: 'Bolle',
    link: 'http://www.giopatocoombes.com/products/bolle/'
  },
  {
    title: 'Bonaldo',
    link: 'https://www.bonaldo.it'
  },
  {
    title: 'Brabbu',
    link: 'https://www.brabbu.com/home/'
  },
  {
    title: 'Busnelli',
    link: 'https://www.busnelli.it/it/'
  },
  {
    title: 'Caccaro',
    link: 'https://www.caccaro.com'
  },
  {
    title: 'Cameron Design House',
    link: 'https://camerondesignhouse.com'
  },
  {
    title: 'Casamania Horm',
    link: 'https://www.horm.it'
  },
  {
    title: 'Catellani Smith',
    link: 'https://www.catellanismith.com/en'
  },
  {
    title: 'Catellan Italia',
    link: 'https://www.cattelanitalia.com'
  },
  {
    title: 'Contardi',
    link: 'http://www.contardi-italia.com/it_index.php'
  },
  {
    title: 'COR',
    link: 'https://www.cor.de/home/'
  },
  {
    title: 'CTO light',
    link: 'https://ctolighting.co.uk'
  },
  {
    title: 'Daytona',
    link: 'https://www.daytonahome.it'
  },
  {
    title: 'DCW Editions',
    link: 'http://dcw-editions.fr/fr'
  },
  {
    title: 'De Castelli',
    link: 'https://www.decastelli.com/collection/'
  },
  {
    title: 'De Padova',
    link: 'https://www.depadova.com'
  },
  {
    title: 'De Sede',
    link: 'https://www.desede.ch/en'
  },
  {
    title: 'Desalto',
    link: 'http://www.desalto.it/it/prodotti/tavoli/beam'
  },
  {
    title: 'Dieffebi',
    link: 'https://www.dieffebi.com/it/homepage/'
  },
  {
    title: 'Ditre',
    link: 'https://www.ditreitalia.com'
  },
  {
    title: 'Desiree',
    link: 'http://www.gruppoeuromobil.com/ita/desiree/index.php'
  },
  {
    title: 'E15',
    link: 'https://www.e15.com/en/'
  },
  {
    title: 'Edra',
    link: 'https://www.edra.com'
  },
  {
    title: 'Effe ti',
    link: 'http://www.effeti.com/it/'
  },
  {
    title: 'EMU',
    link: 'https://www.emu.it'
  },
  {
    title: 'ENNE',
    link: 'http://www.enne.com.tr/en'
  },
  {
    title: 'Erba',
    link: 'https://www.erbaitalia.it'
  },
  {
    title: 'Essential Home',
    link: 'https://www.essentialhome.eu'
  },
  {
    title: 'Ethnicraft',
    link: 'https://www.ethnicraft.com'
  },
  {
    title: 'Fabbian',
    link: 'https://www.fabbian.com/it'
  },
  {
    title: 'Faro Barcelona',
    link: 'https://lightingspain.com/es/marcas/faro.html'
  },
  {
    title: 'Flexform',
    link: 'https://www.flexform.it/en'
  },
  {
    title: 'Flos',
    link: 'https://flos.com'
  },
  {
    title: 'Fontana Arte',
    link: 'http://www.fontanaarte.com/en'
  },
  {
    title: 'Forestier',
    link: 'https://forestier.fr'
  },
  {
    title: 'Formitalia',
    link: 'https://formitalia.it'
  },
  {
    title: 'FreiFrau',
    link: 'https://www.freifrau.eu/de'
  },
  {
    title: 'Frigerio',
    link: 'https://www.frigeriosalotti.it'
  },
  {
    title: 'Gallotti&Radice',
    link: 'https://www.gallottiradice.it'
  },
  {
    title: 'GUN',
    link: 'https://www.gan-rugs.com/es/distributor/projects-contemporary-furniture/'
  },
  {
    title: 'Gervasoni',
    link: 'https://www.gervasoni1882.it/en'
  },
  {
    title: 'Ginger & Jagger',
    link: 'https://www.gingerandjagger.com'
  },
  {
    title: 'Glas Italia',
    link: 'https://www.glasitalia.com'
  },
  {
    title: 'Henge',
    link: 'http://www.henge07.com'
  },
  {
    title: 'Houtique',
    link: 'http://houtique.es/wp'
  },
  {
    title: 'I 4 Mariani',
    link: 'https://www.i4mariani.com/ru/'
  },
  {
    title: 'ICF',
    link: 'https://www.icf-office.it'
  },
  {
    title: 'Janua',
    link: 'https://janua-moebel.com'
  },
  {
    title: 'Jori',
    link: 'https://www.jori.com'
  },
  {
    title: 'Jose Martinez Medina',
    link: 'http://jmm.es/newjmm/sofas/'
  },
  {
    title: 'Jot.jot',
    link: 'http://www.jotjot.com'
  },
  {
    title: 'Karl Andersson',
    link: 'https://www.karl-andersson.se'
  },
  {
    title: 'Karman',
    link: 'https://www.karmanitalia.it/en/'
  },
  {
    title: 'Kartell',
    link: 'http://www.kartell.com/nl'
  },
  {
    title: 'Kettal outdoor',
    link: 'https://www.kettal.com/en/particular/index/'
  },
  {
    title: 'Knoll',
    link: 'https://www.knoll.com'
  },
  {
    title: 'Kristalia',
    link: 'https://www.kristalia.it'
  },
  {
    title: 'Kundalini',
    link: 'https://www.kundalini.it/?lang=en'
  },
  {
    title: 'Lago',
    link: 'https://www.lago.it/ru/'
  },
  {
    title: 'Laurameroni',
    link: 'https://www.laurameroni.com/ru'
  },
  {
    title: 'Lee Broom',
    link: 'http://www.leebroom.com'
  },
  {
    title: 'Living Divani',
    link: 'https://livingdivani.it/en/homepage/'
  },
  {
    title: 'Louis Poulsen',
    link: 'https://www.louispoulsen.com'
  },
  {
    title: 'Luceplan',
    link: 'https://www.luceplan.com'
  },
  {
    title: 'Lampadari',
    link: 'https://www.mmlampadari.com'
  },
  {
    title: 'Magis',
    link: 'https://www.magisdesign.com'
  },
  {
    title: 'Marelli',
    link: 'https://www.giuliomarelli.com'
  },
  {
    title: 'Masiero',
    link: 'http://www.masierogroup.com'
  },
  {
    title: 'Maxalto',
    link: 'https://www.bebitalia.com/ru/maxalto/products'
  },
  {
    title: 'MDF Italia',
    link: 'https://www.mdfitalia.com/en'
  },
  {
    title: 'Melogranoblu',
    link: 'http://www.melogranoblu.com'
  },
  {
    title: 'Merediani',
    link: 'http://www.meridiani.it'
  },
  {
    title: 'Meroni & Colzani',
    link: 'https://www.meroniecolzani.it'
  },
  {
    title: 'Metal Lux',
    link: 'http://www.metalluxlight.com'
  },
  {
    title: 'Modulnova',
    link: 'https://www.modulnova.it'
  },
  {
    title: 'Minotti',
    link: 'https://www.minotti.com/en'
  },
  {
    title: 'MisuraEmme',
    link: 'https://www.misuraemme.it'
  },
  {
    title: 'Mood by Flexform',
    link: 'https://www.flexform.it/en/mood'
  },
  {
    title: 'Moooi',
    link: 'https://www.moooi.com'
  },
  {
    title: 'Morelato',
    link: 'https://www.morelato.it/ita/tag/novità-prodotti'
  },
  {
    title: 'Moroso',
    link: 'https://moroso.it'
  },
  {
    title: 'Moustache',
    link: 'https://www.moustache.fr/fr/'
  },
  {
    title: 'Munna',
    link: 'https://www.munnadesign.com'
  },
  {
    title: 'MY Home collection',
    link: 'http://www.myhomecollection.it'
  },
  {
    title: 'Novamobili',
    link: 'https://www.novamobili.it/it'
  },
  {
    title: 'Nuura',
    link: 'https://www.nuura.com'
  },
  {
    title: 'OAK',
    link: 'http://www.oakdesign.it/it'
  },
  {
    title: 'Oblure',
    link: 'https://oblure.com'
  },
  {
    title: 'Oluce',
    link: 'https://www.oluce.com'
  },
  {
    title: 'Paola Lenti',
    link: 'http://www.paolalenti.it/en/'
  },
  {
    title: 'Pedrali',
    link: 'https://www.pedrali.it/ru/produkciya/kategorii/'
  },
  {
    title: 'Penta',
    link: 'https://pentalight.it'
  },
  {
    title: 'Porada',
    link: 'https://www.porada.it'
  },
  {
    title: 'Porro',
    link: 'https://www.porro.com/en/products/all+products'
  },
  {
    title: 'Porta Romana',
    link: 'https://portaromana.com/ru/collections/'
  },
  {
    title: 'Potocco',
    link: 'https://potocco.it'
  },
  {
    title: 'Pulpo',
    link: 'https://pulpoproducts.com/shop/furniture/'
  },
  {
    title: 'Quasar',
    link: 'https://quasar.dev'
  },
  {
    title: 'Riva 1920',
    link: 'https://www.riva1920.it/it/home/'
  },
  {
    title: 'Roda',
    link: 'https://www.rodaonline.com/en'
  },
  {
    title: 'Rolf Benz',
    link: 'https://www.rolf-benz.com/ru_RU/'
  },
  {
    title: 'Roll & Hill',
    link: 'https://eu.rollandhill.com/collections/view_all'
  },
  {
    title: 'Saba',
    link: 'https://sabaitalia.it'
  },
  {
    title: 'San Giacomo',
    link: 'https://www.msg.it/en/'
  },
  {
    title: 'Sancal',
    link: 'https://sancal.com/es/sofas/'
  },
  {
    title: 'Scab Design',
    link: 'https://www.scabdesign.com'
  },
  {
    title: 'Selva',
    link: 'http://www.philippselva.com/#'
  },
  {
    title: 'Serge Mouille',
    link: 'https://serge-mouille.uber-modern.com/'
  },
  {
    title: 'Sovet Italia',
    link: 'https://www.sovet.com'
  },
  {
    title: 'Tacchini',
    link: 'http://www.tacchini.it/en/'
  },
  {
    title: 'Terzani',
    link: 'https://www.terzani.com/en/home'
  },
  {
    title: 'THONET',
    link: 'http://www.thonet.de/startseite.html'
  },
  {
    title: 'Ton',
    link: 'https://www.ton.eu/en/'
  },
  {
    title: 'GTV. Wiener GTV Design',
    link: 'http://www.gebruederthonetvienna.com'
  },
  {
    title: 'Tonin Casa',
    link: 'https://www.tonincasa.it'
  },
  {
    title: 'Tonino Lamborghini Casa',
    link: 'http://lamborghini-casa.com'
  },
  {
    title: 'Tonon',
    link: 'https://www.tononitalia.com'
  },
  {
    title: 'Tribu outdoor',
    link: 'https://www.tribu.com/en'
  },
  {
    title: 'Turri',
    link: 'http://www.turri.it/?lang=ru'
  },
  {
    title: 'Twils',
    link: 'https://www.twils.it/ita/'
  },
  {
    title: 'Ulivi',
    link: 'https://ulivisalotti.it'
  },
  {
    title: 'Vibia',
    link: 'https://www.vibia.com'
  },
  {
    title: 'Vibieffe',
    link: 'https://www.vibieffe.com'
  },
  {
    title: 'Zanotta',
    link: 'https://www.zanotta.it'
  },
]



// WEBPACK FOOTER //
// ./src/assets/companies.js